export const hoursEn = {
  notifications: {
    'special-hours': {
      create: {
        error: 'Unable to create special hours',
        success: 'Special hours created',
      },
      delete: {
        error: 'Unable to delete special hours',
        success: 'Special hours deleted',
      },
      update: {
        error: 'Unable to update special hours',
        success: 'Special hours updated',
      },
    },
  },
}
